module.exports = __webpack_public_path__ + "static/chp-ad-2-c3ac4222dfe9b0e41eacbba74f7e4455.jpg";